import React, {useContext, useState} from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import SystemContext from "../SystemContext";
import {updateUserMetaData} from "../auth/metaData"
import {AccessControl, setUserInfo, getUserRoles} from "../AccessControl";
import { useTheme } from '@material-ui/core';

const UserProfile = (props) => {

  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const currentUser = "User Profile (" + props.user.name + ")";

  const [userProfileData, setUserProfileData] = useState({
    userName: currentUser,
    firstName: AccessControl.userInfo ?  AccessControl.userInfo.firstName : "",
    lastName: AccessControl.userInfo ?  AccessControl.userInfo.lastName : "",
    department: "",
    openAlert: false,
    alertTitle: "",
    alertMessage: ""
  });

  const updateUserData = async () => {
    const metaData = {
      firstName: userProfileData.firstName,
      lastName: userProfileData.lastName,
      department: userProfileData.department
    }
    const response = await updateUserMetaData(props.user.sub, metaData);
    if (response) {
      setUserInfo(response);
    }
  }

  function handleClose() {
    props.onChange();
  }

  const updateUserProfile = async () => {
    if (userProfileData.firstName === "") {
      SystemData.openAlert(
        "Required Field",
        "Please provide value for 'First Name'"
      );
      document.getElementById("firstName").focus();
      return;
    }
    if (userProfileData.lastName === "") {
      SystemData.openAlert(
        "Required Field",
        "Please provide value for 'Last Name'"
      );
      document.getElementById("lastName").focus();
      return;
    }

    await updateUserData();
    handleClose();
  }

  const renderUserRoles = () => {
    const userRoles = getUserRoles(props.user);
    let userRoleList = "";
    if (userRoles && userRoles.length > 0) {
      userRoles.map((role) => {
        return userRoleList += (userRoleList !== "" ? ", " : "")  +  role;
      });

      return (
        <div>
          <div style={{clear: "both", padding:"10px", border: "groove"}}>
            <h2 style={{margin:"2px 2px", fontSize:16, fontWeight:400, fontFamily:"Ubuntu, sans-serif"}}>
              <span>Assigned System Roles:</span>
            </h2>
            <DialogContentText>
              <span style={{
                lineHeight:"22px",
                display:"block",
                padding:"10px 10px",
                color: "primary",
                fontSize: 18,
                fontWeight: 500,
                fontFamily:"Ubuntu,sans-serif",
                textDecoration: "none"}}
              >
                {userRoleList}
              </span>
            </DialogContentText>
          </div>
          <div style={{padding:"10px"}}/>
        </div>
      );
    }
    else {
      return (<></>);
    }
  }

  return (
    <div id={"UserProfile"}>
      <Dialog open={props.open}
              onClose={(event, reason) => {if (reason !== 'backdropClick') handleClose()}}
              aria-labelledby="form-dialog-title"
              // disableBackdropClick={true}
      >
        <DialogTitle id="form-dialog-title">
          <div style={{clear: "both", backgroundColor: theme.palette.primary.main, padding:"10px"}}>
          {currentUser}
          </div>
        </DialogTitle>
        <DialogContent>
          <div>{renderUserRoles()}</div>
          <DialogContentText>
            To update profile, please enter the required information in the fields below
          </DialogContentText>
          <TextField
            id="firstName"
            margin="normal"
            required
            fullWidth
            name="First Name"
            value={userProfileData.firstName}
            label="First Name"
            placeholder="Enter first name"
            autoFocus
            onChange={(event) => {
              const firstName = event.target.value;
              setUserProfileData({...userProfileData, firstName});
            }}
          />

          <TextField
            id="lastName"
            margin="normal"
            required
            fullWidth
            name="Last Name"
            value={userProfileData.lastName}
            label="Last Name"
            placeholder="Enter last name"
            onChange={(event) => {
              const lastName = event.target.value;
              setUserProfileData({...userProfileData, lastName});
            }}
          />
          <TextField
            id="department"
            margin="normal"
            fullWidth
            name="Department"
            value={userProfileData.department}
            label="Department"
            placeholder="Enter last name"
            onChange={(event) => {
              const department = event.target.value;
              setUserProfileData({...userProfileData, department});
            }}
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={updateUserProfile} color="primary">
            Update Profile
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}

export default UserProfile;
